import React, {useState} from 'react';
import Button from "../Button";
import UploadFileModal from "../../modals/UploadFileModal";
import Tile from "./components/Tile";
import Row from "./components/Row";
import DeleteFileModal from "../../modals/DeleteFileModal";
import _ from "lodash";

export const FILE_UPLOADER_LAYOUT = {
    ROW:    "row",
    TILE:   "tile",
}

const MultiFileUploader = (props) => {
    const {
        title           = "Attachments",
        singleItemLabel = "Attachment",
        multiItemLabel  = "Attachments",
        layout          = FILE_UPLOADER_LAYOUT.ROW,
        files           = [],
        onUpdate        = (files) => {},
        parentId        = "",
    } = props;

    const [uploadFileModal, setUploadFileModal] = useState(false);
    const [deleteFileModal, setDeleteFileModal] = useState(false);

    const handleFilesUpload = (newFiles) => {
        onUpdate([...files, ...newFiles]);
        setUploadFileModal(false);
    }

    const handleFileDelete = (file) => {
        const clone = _.cloneDeep(files);

        for (let i = 0; i < clone.length; i++) {
            if (clone[i].id === file.id) {
                clone[i] = file;
                break;
            }
        }

        onUpdate(clone);
        setDeleteFileModal(null);
    }

    const renderNoFiles = () => {
        return (
            <div className={"empty-files mb-4 text-eh-off-black text-center user-select-none"}>
                <small>No {multiItemLabel} Uploaded</small>
            </div>
        );
    }

    const renderFiles = () => {
        const filteredFiles = files.filter((file) => {
            return parseInt(file.deleted) !== 1;
        })

        if (layout === FILE_UPLOADER_LAYOUT.TILE) {
            return (
                <div className={"attachments-tile-layout"}>
                    {filteredFiles.map((file, index) => {
                        return (
                            <Tile
                                key={file.id}
                                file={file}
                                onDelete={() => setDeleteFileModal(file)}
                            />
                        )
                    })}
                </div>
            );
        } else {
            return (
                <div className={"attachments-row-layout"}>
                    {filteredFiles.map((file, index) => {
                        return (
                            <Row
                                key={file.id}
                                file={file}
                                onDelete={() => setDeleteFileModal(file)}
                            />
                        )
                    })}
                </div>
            );
        }

    }

    return (
        <React.Fragment>
            <div className={"multi-file-uploader mb-4"}>
                <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-3">
                    <h2 className="h6 mb-0 text-eh-navy">{title}</h2>
                </div>
                <div className="row m-0 p-0">
                    <div className="col-12 m-0 p-0">
                        {!!files && files.length < 1 ? renderNoFiles() : renderFiles()}
                    </div>
                </div>
                <div className="row m-0 p-0">
                    <div className="col-12 m-0 p-0">
                        <Button
                            onClick={() => setUploadFileModal(true)}
                            label={"Add "+singleItemLabel}
                            icon={"far fa-plus-circle"}
                            classes={"btn btn-outline-eh-navy m-0"}
                        />
                    </div>
                </div>
            </div>
            <UploadFileModal
                show={uploadFileModal}
                parentId={parentId}
                onCancel={() => setUploadFileModal(false)}
                onComplete={(files) => handleFilesUpload(files)}
                singleItemLabel={singleItemLabel}
                multiItemLabel={multiItemLabel}
            />
            <DeleteFileModal
                show={!!deleteFileModal}
                file={!!deleteFileModal ? deleteFileModal : null}
                parentId={parentId}
                onCancel={() => setDeleteFileModal(null)}
                onConfirm={(file) => handleFileDelete(file)}
            />
        </React.Fragment>
    );
}

export default MultiFileUploader;
